import { Tag } from "antd";
import { colors } from "@libertify/ui/theme-v2";
import type { InsightPriority } from "../../types";

const priorityConfig: Record<
  InsightPriority,
  { label: string; backgroundColor: string; color: string }
> = {
  Urgent: {
    label: "Urgent",
    backgroundColor: colors.status.errorBg,
    color: colors.status.error,
  },
  Important: {
    label: "Important",
    backgroundColor: colors.status.warningBg,
    color: colors.status.warning,
  },
  NiceToHave: {
    label: "Nice to have",
    backgroundColor: colors.border.muted,
    color: colors.text.secondary,
  },
};

export const InsightPriorityTag = ({
  priority,
}: {
  priority: InsightPriority;
}) => {
  const config = priorityConfig[priority];
  return (
    <Tag
      color={config.backgroundColor}
      style={{
        color: config.color,
        borderRadius: 20,
        fontSize: 10,
        padding: "0 7px",
        fontWeight: 600,
        border: "none",
        letterSpacing: 0.04,
      }}
    >
      {config.label}
    </Tag>
  );
};
